import React from 'react';

import { Container } from 'Components/core';

import Content from './InfoBoxContent';
import Header from './InfoBoxHeader';
import Hero from './InfoBoxHero';

export default class InfoBox extends React.Component {
  render() {
    return (
      <Container column seperator="32px">
        <Header>{this.props.header}</Header>
        <Hero image={this.props.image}></Hero>
        <Content column seperation="16px">{this.props.children}</Content>
      </Container>
    );
  }
}
